import { View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const obligations = [
  {
    title: "Conduct of Business",
    content:
      "The Appointed Representative shall comply with the provisions set out in Schedule one, and:",
    clauses: [
      {
        content:
          "The Appointed Representative shall comply with such minimum key performance measures as the Company may specify.",
      },
      {
        content:
          "This Contract may be terminated should the Appointed Representative fail to achieve minimum performance levels.",
      },
    ],
  },
  {
    title: "Obligation to enter into Guarantee",
    clauses: [
      {
        content:
          "Where the Appointed Representative is a company or LLP, to procure that the directors, shareholders or Appointed Representatives enter into and provide the guarantee.",
      },
    ],
  },
  {
    title: "Payments",
    content: "To pay to the Company:",
    clauses: [
      {
        content:
          "Any amounts which may be charged by the Company under this Contract for training of the Appointed Representative.",
      },
      {
        content: "Any other payments or charges as set out in this.",
      },
    ],
  },
  {
    title: "Intellectual Property Right",
    content: "",
    clauses: [
      {
        content:
          "Intellectual Property belonging to the Company may be used by the Appointed Representative as permitted by this Contract but shall remain in the ownership of the Company whether relating to name, corporate symbols, logos or otherwise.",
      },
      {
        content:
          "The Appointed Representative shall on the termination of this contract cease to use the Intellectual Property except as otherwise agreed by the Company in writing.",
      },
      {
        content:
          "The Appointed Representative shall not use any name, corporate symbol, logo or other mark similar to or capable of being confused with the trading name or the trademarks of the Company except as otherwise agreed by the Company in writing.",
      },
      {
        content:
          "The Appointed Representative is required to maintain a valid Data ProtectionLicence obtained from the Office of the Information Commissioner.",
      },
    ],
  },
  {
    title: "General Data Protection Obligations (GDPR)",
    content: "",
    clauses: [
      {
        content:
          "The provisions which follow set out the framework for the sharing of “personal data” between the Parties as data controllers (as defined by the General Data Protection Legislation). Each party acknowledges that one party (“the Data Discloser”) will regularly disclose to the other party (“the Data Recipient”) Shared Personal Data collected by the Data Discloser for the Agreed Purposes. Each party shall:",
        subContent: [
          {
            content:
              "ensure that it has all necessary consents and notices in place toenable lawful transfer of the Shared Personal Data to the Data Recipient for the Agreed Purposes.",
          },
          {
            content:
              "give full information to any data subject whose personal data may be processed under this Contract of the nature such processing. This includes giving notice that, on the termination of this Contract, personal data relating to them may be retained by or, as the case may be, transferred to one or more of the Data Recipients, their successors and assigns.",
          },
          {
            content:
              "process the Shared Personal Data only for the Agreed Purposes.",
          },
          {
            content:
              "not disclose or allow access to the Shared Personal Data to anyone other than the Permitted Recipients.",
          },
          {
            content:
              "ensure that all Permitted Recipients are subject to written contractual obligations concerning the Shared Personal Data (including obligations of confidentiality) which are no less demanding than those imposed by this Contract.",
          },
          {
            content:
              "process no other personal data acquired in connection with this Contract other than the Shared Personal Data.",
          },
          {
            content:
              "ensure that it has in place appropriate technical and organisational masures, reviewed and approved by the other party, to protect against unauthorised or unlawful processing of personal data and against accidental loss or destruction of, or damage to, personal data.",
          },
          {
            content:
              "not transfer any personal data outside of the European Economic Area unless the prior written consent of the data subject has been obtained and the following conditions are fulfilled: ",
            subContent: [
              {
                content:
                  "the data subject has enforceable rights and effective legal remedies with regard to the transferred personal data.",
              },
              {
                content:
                  "the transferring party complies with its obligations under the GDPR by providing an adequate level of protection to any personal data that is transferred.",
              },
            ],
          },
          {
            content:
              "comply with the GDPR and agrees that any material breach of the GDPR shall, if not remedied within 30 days of written notice from the other party, give grounds to the other party to terminate this Contract with immediate effect.",
          },
          {
            content:
              "assist the other in complying with all applicable requirements of the GDPR. In particular, each party shall:",
            subContent: [
              {
                content:
                  "allow the other party to approve and, if the other party deems necessary, to amend any notices given to data subjects in relation to the Shared Personal Data.",
              },
              {
                content:
                  "promptly inform the other party about the receipt of any data subject access request.",
              },
              {
                content:
                  "provide the other party with reasonable assistance in complying with any data subject access request.",
              },
              {
                content:
                  "not disclose or release any Shared Personal Data in response to a data subject access request without first consulting with and obtaining the consent of the other party.",
              },
              {
                content:
                  "assist the other party, at the cost of the other party, in responding to any request from a data subject and in ensuring compliance with its obligations under the GDPR with respect to security, breach notifications, impact assessments and consultations with supervisory authorities or regulators.",
              },
              {
                content:
                  "notify the other party without undue delay on becoming aware of any breach of the GDPR.",
              },
              {
                content:
                  "at the written direction of any data subject, delete or return personal data and copies thereof to the data subject on termination of this Contract unless required by law to store the personal data.",
              },
              {
                content:
                  "use compatible technology for the processing of Shared Personal Data to ensure that there is no lack of accuracy resulting from personal data transfers.",
              },
              {
                content:
                  "maintain complete and accurate records and information to demonstrate its compliance with this clause 8 and allow for audits by the other party or the other party's designated auditor.",
              },
              {
                content:
                  "provide the other party with contact details of at least one employee as point ofcontact and responsible manager for all issues arising out of the Data Protection Legislation, including the joint training of relevant staff, the procedures to be followed in the event of a data security breach, and the regular review of the Parties' compliance with the Data Protection Legislation.",
              },
            ],
          },
        ],
      },
      {
        content:
          "Each party shall indemnify the other against all claims and proceedings and all liability, loss, costs and expenses incurred by the other as a result of any claim made or brought by a data subject or other legal person in respect of any loss, damage or distress caused to them as a result of any breach by the other party of the Data Protection Legislation by that party, its Employees or agents, provided that the indemnified party gives to the indemnifier prompt notice of such claim, full information about the circumstances giving rise to it, reasonable assistance in dealing with the claim and sole authority to manage, defend and/or settle it. ",
      },
      {
        content:
          "For the proposes of this agreement processor, data processor, data subject, personal data, processing and appropriate technical and organisational measures shall be as set out in the GDPR Legislation in force at the time.",
      },
    ],
  },
  {
    title: "Confidentiality",
    content: "",
    clauses: [
      {
        content:
          "Not at any time during or after the termination of the contract to disclose or allow to be disclosed (or to use after the termination of this contract) any confidential information to any person without the express written consent of the Company unless required to do so by order of a court, an appropriate regulatory authority or as otherwise required by law.",
      },
      {
        content:
          "The Appointed Representative should not, under any circumstances, grant interviews to the press or television, either face to face, over the telephone or other electronic media, without first seeking approval from the Company’s Board of Directors. This does not preclude the Appointed Representative from advertising their business subject to the advertising approvals process of the Company.",
      },
    ],
  },
  {
    title: "Inspection of records and premises",
    content:
      "To permit the Company and its auditors at all reasonable times to enter any premises used for the purposes of the Business to inspect all records material to the Business as covered by this Contract. ",
  },
  {
    title: "Compliance with Regulations",
    content:
      "To comply with the regulations and to ensure that any personnel related to the business or Sales Activities comply with the regulations.",
  },
  {
    title: "Assignment and Novation",
    content:
      "Not to assign, novate or otherwise transfer either in whole or in part its rights or obligations under this Contract to any other person without the written consent of the Company.",
  },
  {
    title: "IT Software",
    content:
      "To maintain computer hardware for use with such software as prescribed by the Company to fulfil the obligations set out under compliance procedures by the Company.",
  },
  {
    title: "Indemnity",
    content: "",
    clauses: [
      {
        content:
          "Subject to the provisions of this clause, the Appointed Representative shall indemnify the Company in respect of any payments made by the Company or losses suffered by the Company pursuant to any legal liability or on an exgratia basis without admission of liability to Clients (or for the benefit of Clients) or to other third Parties which the Company after investigation reasonably determines it is obliged to make as a result of negligence, breach of duty, misrepresentation or the breach of any provision of this Contract by the Appointed Representative, its staff, servants or agents.",
      },
      {
        content:
          "For the purposes of clause 4.11.1. above, the Company losses shall be deemed to include any administration or legal expenses or costs it has suffered or incurred as a result of dealing with any complaint.",
      },
      {
        content:
          "Any payment required to be made under the provisions of clause 4.11.1. shall be abated by any payment required to be made to or for the benefit of the Appointed Representative by the Company under the provisions of the Professional Indemnity Arrangement.",
      },
      {
        content:
          "The Appointed Representative is required to maintain a valid Data ProtectionLicence obtained from the Office of the Information Commissioner.",
      },
    ],
  },
];

const AppointedRepresentativesObligations = ({ serialNumber = 4 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="appointed-representatives-obligations"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        The Appointed Representative's Obligations
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default AppointedRepresentativesObligations;
